import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD8ErpPNzLWhLVcOUylcjl8Lmz97ohMHgE",
  authDomain: "app-feedback-analysis.firebaseapp.com",
  projectId: "app-feedback-analysis",
  storageBucket: "app-feedback-analysis.firebasestorage.app",
  messagingSenderId: "861958877353",
  appId: "1:861958877353:web:38405238b3617d4d7039b8"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const functions = getFunctions(app);
export const db = getFirestore(app);

// Connect to emulators in development
if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') {
  connectFunctionsEmulator(functions, "localhost", 5001);
  connectFirestoreEmulator(db, "localhost", 8080);
  console.log("Connected to Firebase emulators (Functions: 5001, Firestore: 8080)");
}
